// Import Dependencies
import { useNavigation } from "react-router";

// Local Imports
import { NProgress } from "@/components/shared/NProgress";

// ----------------------------------------------------------------------

export function Progress() {
  const navigation = useNavigation();

  console.log("Navigation State:", navigation.state);

  const isLoading: boolean =
    navigation.state === "loading" &&
    navigation.formData == null &&
    !!navigation.location?.pathname;

  return <NProgress isAnimating={isLoading} />;
}
